import $ from 'jquery';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import BuildFilterQS from '../../helpers/BuildFilterQS';
import config from '../../config/config';
import {searchService} from './search';
import {reportsService} from './reports';

export const projectsService = {
    getProjects,
    getTopProjects,
    getProjectsAutocomplete,
    getCard,
    getCatalogCard,
    getStreamsStats,
    getProjectsByBarcode,
    getTracks,
    getMetadata,
    getTimeseriesProjects,
};

function getProjects(params, globalFilter){
    return true || config.live ? getProjectsNew(params, globalFilter) : getProjectsStatic();
}

function getProjectsByBarcode(barcodes){
  const options = {
    method: 'GET',
    headers: AuthHeader()
  }
  const params = barcodes.endsWith(',') ? barcodes.replace(/\,+$/, '') : barcodes;
  const url = `${config.apis.miniCat}/v2/projects/by_barcode/${params}`;
  return fetch(url, options)
  .then( response => response.json())
  .catch( error => Promise.reject(error));
}

function getTopProjects(params, globalFilter){
    return config.live ? getTopProjectsLive(params, globalFilter) : getTopProjectsStatic();
}

function getTopProjectsLive(params, globalFilter = {}) {
    let baseUrl = config.apis.secStat+'/top_projects',
        qs = BuildQS(globalFilter),
        requestOptions = {
            headers: AuthHeader()
        };

    // qs.query_name = 'top_projects';
    // qs.offset = 0;
    qs.mode = 'main';
    let {sorted, filtered, page } = params;
    if(sorted !== undefined){
        qs.order_by = sorted.field;
        qs.order_dir = sorted.dir;
    }

    if(filtered !== undefined && filtered.length){
        for(let filter of filtered) {
            let value = filter.value;
            if(!value && !qs[filter.id])
                continue;
            if(value instanceof Array) {
                value = value.join(',');
                if(!value)
                    continue;
                qs[filter.id] = value;
            }
            else {
                qs[filter.id] = value;
            }
        }
    }
    if(page !== undefined){
        qs.offset = Number(page)*qs.limit; 
    }

    baseUrl += '?' + $.param(qs);

    return fetch(baseUrl, requestOptions)
        .then(res=>res.json());
}



function getTopProjectsStatic() {
    let baseUrl = `${config.apis.sales}/api/static/sec/top_projects.json`;
    return fetch(baseUrl).then(res=>res.json());
}
/*
function getTopProjectsStatic() {
    return Promise.resolve(topProjects);    
}
*/

function getProjectsNew(params, globalFilter = {}) {
    let baseUrl = config.apis.secStat+'/top_projects',
        qs = BuildQS(globalFilter);

    // qs.query_name = 'top_projects';
    // qs.offset = 0;
    qs.mode = 'main';
    qs.result = 'sql'; // !!!
    let {sorted, filtered, page } = params;
    if(sorted !== undefined){
        qs.order_by = sorted.field;
        qs.order_dir = sorted.dir;
    }

    if(filtered !== undefined && filtered.length){
        for(let filter of filtered) {
            let value = filter.value;
            if(!value)
                continue;
            if(value instanceof Array) {
                value = value.join(',');
                if(!value)
                    continue;
                qs[filter.id] = value;
            }
            else {
                qs[filter.id] = value;
            }
        }
    }
    if(page !== undefined){
        qs.offset = Number(page)*qs.limit; 
    }

    baseUrl += '?' + $.param(qs);
    return reportsService.createReport(baseUrl);
}

function getProjectsStatic(params) {
    let baseUrl = `${config.apis.sales}/api/static/projects.json`;
    return fetch(baseUrl, {})
    .then(res=>{
        return res.json()
    });
}

function getProjectsAutocomplete(input) {
    return searchService.autocomplete(input, ['projects']);
}

function getCard(id) {
    let baseUrl = `${config.apis.secStat}/project_details`,
        requestOptions = {
            headers: AuthHeader()
        };
    let qs = BuildQS({});
    qs.projects=id;
    baseUrl += '?' + $.param(qs);
    return fetch(baseUrl, requestOptions)
    .then(res=>{
        return res.json()
    });
}

function getCatalogCard(id) {
    let fields = 'id,name,logo_file_name',
        baseUrl = `${config.apis.miniCat}/v2/projects/${id}?fields=${fields}`,
        requestOptions = {
            headers: AuthHeader()
        };
    return fetch(baseUrl, requestOptions)
    .then(res=>{
        return res.json()
    });
}


function getStreamsStats(ids, globalFilter) {
    return config.live ? getStreamsStatsLive(ids, globalFilter) : getStreamsStatsStatic();
}

function getStreamsStatsLive(ids, globalFilter) {

    //
    const params = {
        sorted:[{id: 'curr_units', 'desc': true}],
        filtered: [{id:'ids', value:ids}]
    }
    //

    let baseUrl = config.apis.v3_data+'/simple',
    qs = BuildQS(globalFilter),
    requestOptions = {
        headers: AuthHeader()
    };

    qs.query_name = 'top_projects';
    // qs.offset = params.page ? params.page*globalFilter.limit : 0;
    qs.mode = 'timeseries_ids';

    let {sorted, filtered} = params;
    if(sorted !== undefined && sorted.length){
        sorted = sorted[0];
        qs.order_by = sorted.id;
        qs.order_dir = sorted.desc ? 'desc':'asc';
    }

    if(filtered !== undefined && filtered.length){
        for(let filter of filtered) {
            let value = filter.value;
            if(!value)
                continue;
            if(value instanceof Array) {
                value = value.join(',');
                if(!value)
                    continue;
                qs[filter.id] = value;
            }
            else {
                qs[filter.id] = value;
            }
        }
    }

    baseUrl += '?' + $.param(qs).replace(/%2C/g,',');

    return fetch(baseUrl, requestOptions)
    .then(res=>{
        return res.json()
    });
}

function getStreamsStatsStatic() {
    let baseUrl = `${config.apis.sales}/api/static/top_projects_streams.json`;
    return fetch(baseUrl, {})
    .then(res=>{
        return res.json()
    })
}

function getTracks(product_ids) {
    let baseUrl = `${config.apis.miniCat}/v2/projects/acl_tracks`,
        requestOptions = {
            headers: AuthHeader({'Content-Type': 'application/json'}),
            method: 'POST',
            body: JSON.stringify({product_ids})
        };
        
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    });

}

function getMetadata(ids){
    return config.live ? getMetadataLive(ids) : getMetadataStatic();
}

function getMetadataLive(ids) {
    let baseUrl = `${config.apis.miniCat}/v3/projects/by_id`,
        requestOptions = {
            method: 'POST',
            headers: AuthHeader({'Content-Type': 'application/json'}),
            body: JSON.stringify({project_ids: ids})
        };
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    });
}

function getMetadataOld(ids) {
    let baseUrl = `${config.apis.miniCat}/v2/projects/by_id`,
        requestOptions = {
            method: 'POST',
            headers: AuthHeader({'Content-Type': 'application/json'}),
            body: JSON.stringify({projects_ids: ids})
        };
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    });
}

function getMetadataStatic() {
    let baseUrl = `${config.apis.sales}/api/static/sec/top_projects_metadata.json`;
    return fetch(baseUrl, {})
    .then(res=>{   
        return res.json()
    });
}

/*
function getMetadataStatic() {
    return Promise.resolve(projectsMetadata);    
}
*/


function getTimeseriesProjects(params, globalFilter){
    return config.live ? getTimeseriesProjectsLive(params, globalFilter) : getTimeseriesProjectsStatic();
}

function getTimeseriesProjectsLive(params, globalFilter={}) {
    /*
    const params = {
        sorted:[{id: 'curr_units', 'desc': true}],
        filtered: [{id:'ids', value:ids}]
    }
    */
    
	let baseUrl = config.apis.secStat+'/top_projects',
        qs = BuildQS(globalFilter),
        requestOptions = {
            headers: AuthHeader()
        };

    // qs.offset = 0;
    qs.mode = 'timeseries';

    let {sorted, filtered} = params;
    if(sorted !== undefined){
        qs.order_by = sorted.field;
        qs.order_dir = sorted.dir;
    }

    if(filtered !== undefined && filtered.length){
        for(let filter of filtered) {
            let value = filter.value;
            if(!value && !qs[filter.id])
                continue;
            const key = filter.id == 'ids' ? 'projects' : filter.id;
            if(value instanceof Array) {
                value = value.join(',');
                if(!value)
                    continue;
                qs[key] = value;
            }
            else {
                qs[key] = value;
            }
        }
    }

    baseUrl += '?' + $.param(qs);
    return fetch(baseUrl, requestOptions)
        .then(res=>res.json());
}


function getTimeseriesProjectsStatic() {
    let baseUrl = `${config.apis.sales}/api/static/sec/top_projects_timeseries.json`;
    return fetch(baseUrl).then(res=>res.json());
}